/*
 * File: SalesOrderFilters.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 16 Nov 2021 1:28:39 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { DeleteOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { CreatedBySearch } from 'components/atoms/salesOrderFilters/CreatedBySearch';
import { CreatedDateTimeSearch } from 'components/atoms/salesOrderFilters/CreatedDateTimeSearch';
import { CustomerIdSearch } from 'components/atoms/salesOrderFilters/CustomerIdSearch';
import { CustomerNameSearch } from 'components/atoms/salesOrderFilters/CustomerNameSearch';
import { CustomerPOSearch } from 'components/atoms/salesOrderFilters/CustomerPOSearch';
import { DraftIdSearch } from 'components/atoms/salesOrderFilters/DraftIdSearch';
import { QuoteIdSearch } from 'components/atoms/salesOrderFilters/QuoteIdSearch';
import { RequestedShipDateRangeSearch } from 'components/atoms/salesOrderFilters/RequestedShipDateRangeSearch';
import { SalesOrderNumberSearch } from 'components/atoms/salesOrderFilters/SalesOrderNumberSearch';
import { SalesPersonSearch } from 'components/atoms/salesOrderFilters/SalesPersonSearch';
import { StatusSearch } from 'components/atoms/salesOrderFilters/StatusSearch';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ordersSlice } from 'redux/salesOrder/ordersSlice';
import { setSelectedSalesOrders } from 'redux/salesOrder/selectedSalesOrdersSlice';

const styles: InlineStylesModel = {
  searchRow: {
    padding: '20px 10px',
    backgroundColor: 'white'
  },
  searchSalesOrderHeadline: {
    fontSize: '17px',
    marginBottom: 10,
    paddingLeft: 10
  }
};

export const SalesOrderFilters = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isRecoverPage = location.pathname.includes('recover');

  const handleNavigateToRecover = (): void => {
    navigate('recover');
    dispatch(ordersSlice.actions.resetForm());
  };

  const handleNavigateHome = (): void => {
    navigate('/');
    dispatch(setSelectedSalesOrders([]));
    dispatch(ordersSlice.actions.resetForm());
  };

  return (
    <>
      <Row style={styles.searchSalesOrderHeadline} align="middle" justify="space-between">
        <Col>{location.pathname.includes('recover') ? 'Search Sales Orders - Recycle Bin' : 'Search Sales Orders'}</Col>
        <Col>
          {!isRecoverPage ? (
            <Button onClick={handleNavigateToRecover} icon={<DeleteOutlined />}>
              Recycle Bin
            </Button>
          ) : (
            <Button onClick={handleNavigateHome}>Back to Sales Orders</Button>
          )}
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={styles.searchRow} justify="start">
        <Col>
          <SalesOrderNumberSearch />
        </Col>
        <Col>
          <CustomerNameSearch />
        </Col>
        <Col>
          <CustomerIdSearch />
        </Col>
        <Col>
          <CustomerPOSearch />
        </Col>
        <Col>
          <SalesPersonSearch />
        </Col>
        <Col>
          <QuoteIdSearch />
        </Col>
        <Col>
          <DraftIdSearch />
        </Col>
        <Col>
          <CreatedBySearch />
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={styles.searchRow}>
        <Col>
          <StatusSearch />
        </Col>
        <Col>
          <CreatedDateTimeSearch />
        </Col>
        <Col>
          <RequestedShipDateRangeSearch />
        </Col>
      </Row>
    </>
  );
};
